import LabeledField from '../../components/LabeledField';
import { useSelectStyles } from './Select.styles';

// Resolved option handed to the rendered <option> (label is a plain string).

// Authored option in card JSON: its label may itself be a formattable binding.
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Select = ({
  name,
  value,
  options,
  label,
  labelLayout,
  width = 'full',
  placeholder,
  required,
  isDisabled = false,
  onChange
}) => {
  const {
    selectStyle
  } = useSelectStyles({
    isDisabled,
    width
  });
  const selectId = `select-${name}`;
  const handleChange = e => {
    onChange(name, e.target.value);
  };
  return /*#__PURE__*/_jsx(LabeledField, {
    htmlFor: selectId,
    label: label,
    required: required,
    labelLayout: labelLayout,
    children: /*#__PURE__*/_jsxs("select", {
      id: selectId,
      value: value,
      onChange: handleChange,
      required: required,
      disabled: isDisabled,
      style: selectStyle,
      children: [placeholder && /*#__PURE__*/_jsx("option", {
        value: "",
        disabled: true,
        children: placeholder
      }), options.map(option => /*#__PURE__*/_jsx("option", {
        value: option.value,
        children: option.label
      }, option.value))]
    })
  });
};
export default Select;